import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function DSPResults(props) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Age</TableCell>
            <TableCell>Gender</TableCell>
            <TableCell>Symptoms</TableCell>
            <TableCell>Diagnosis</TableCell>
            <TableCell>Adverse Event</TableCell>
            <TableCell>Treatment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.map((row) => (
            <TableRow key={row.Age}>
              <TableCell component="th" scope="row">
                {row.Age}
              </TableCell>
              <TableCell>{row.Gender}</TableCell>
              <TableCell>{row.Symptoms}</TableCell>
              <TableCell>{row.Diagnosis}</TableCell>
              <TableCell>{row.ADE}</TableCell>
              <TableCell>{row.Treatment}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
